import styled from 'styled-components';
import { Mail } from 'lucide-react';

export const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  padding: 24px 32px;
  gap: 20px;
  background: #fff;
  min-height: 0;
`;

export const EmailIcon = styled(Mail)`
  width: 20px;
  height: 20px;
  color: #555;
`;